export default {
  props: {
    apiUrl: {
      type: String,
      required: true,
    },
    maxAge: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    getCookieValue(name) {
      const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return value ? value.pop() : '';
    },
    async lookUpOrSave(key) {
      let storageData = window.sessionStorage.getItem(key);
      if (storageData) {
        storageData = JSON.parse(storageData);
        storageData.updated = new Date(storageData.updated);
        if (((new Date() - storageData.updated) / 1000) <= this.maxAge) {
          if (!storageData?.result) {
            // eslint-disable-next-line max-len
            // console.info(this.$options.name.toUpperCase(), `is waiting for storage item ${key} to be manipulated`);
            return new Promise((resolve) => {
              document.addEventListener(`${key}Set`, (event) => {
                if (event?.detail?.storageData?.result) {
                  // console.info(this.$options.name.toUpperCase(), 'can now use api result');
                  resolve(event.detail.storageData.result);
                } else {
                  this.apiError = true;
                  window.sessionStorage.removeItem(key);
                }
              });
            });
          }
          // console.info(this.$options.name.toUpperCase(), 'Using cached api result directly');
          return storageData.result;
        }
      }

      // console.info(this.$options.name.toUpperCase(), 'is requesting api');
      window.sessionStorage.setItem(key, JSON.stringify({ updated: new Date() }));
      const result = await this.$http.get(this.apiUrl, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${this.getCookieValue('Authorization')}`,
          'Content-Type': 'application/json',
        },
      }).catch(() => {
        this.apiError = true;
      });

      if (this.apiError) {
        window.sessionStorage.removeItem(key);
      } else {
        // console.info(this.$options.name.toUpperCase(), `is setting storage item ${key}`);
        window.sessionStorage.setItem(key, JSON.stringify({
          updated: new Date(),
          result: result?.data,
        }));
      }

      document.dispatchEvent(new CustomEvent(`${key}Set`, {
        detail: {
          storageData: {
            updated: new Date(),
            result: result?.data,
          },
        },
        bubbles: true,
        cancelable: false,
      }));
      return result?.data;
    },
    async getAwardsApiResult() {
      return this.lookUpOrSave('loyaltyAwardsData');
    },
    async getUserApiResult() {
      return this.lookUpOrSave('loyaltyUserData');
    },
  },
};
